import React from "react";
import CarteHorsConnexion, {
  LienEspaceClient,
} from "../../common/CarteHorsConnexion/CarteHorsConnexion";
import Loader from "../../common/Loader";
import Page from "../../common/layout/Page";
import useActivateAccount, { ETATS } from "./useActivateAccount";

const Icone = ({ nom, ton }) => (
  <i
    className={`fa ${nom} carte-hors-connexion__icone ${ton}`}
    aria-hidden="true"
  />
);

// Contenu de chaque état sans action propre : titre, pictogramme, explication.
const MESSAGES = {
  [ETATS.ACTIVE]: {
    titre: "Votre compte est activé",
    icone: <Icone nom="fa-check-circle" ton="text-success" />,
    texte: "Vous pouvez maintenant accéder à votre espace client.",
  },
  [ETATS.DEJA_ACTIVE]: {
    titre: "Votre compte est déjà activé",
    icone: <Icone nom="fa-check-circle" ton="text-success" />,
    texte:
      "Ce lien a déjà servi. Vous pouvez accéder directement à votre espace client.",
  },
  [ETATS.EXPIRE]: {
    titre: "Ce lien d'activation a expiré",
    icone: <Icone nom="fa-clock" ton="text-danger" />,
    texte:
      "Connectez-vous à votre espace client : vous pourrez y recevoir un nouveau lien d'activation.",
  },
  [ETATS.INVALIDE]: {
    titre: "Ce lien d'activation n'est pas valide",
    icone: <Icone nom="fa-unlink" ton="text-danger" />,
    texte:
      "Vérifiez que vous avez ouvert le lien complet reçu par e-mail. Vous pouvez aussi vous connecter pour recevoir un nouveau lien.",
  },
};

const ActivateAccount = (props) => {
  const { etat, activer, echecActivation, reessayer } = useActivateAccount(
    props.match.params.token
  );

  if (MESSAGES[etat]) {
    const { titre, icone, texte } = MESSAGES[etat];
    return (
      <Page>
        <CarteHorsConnexion titre={titre}>
          {icone}
          <p className="carte-hors-connexion__texte">{texte}</p>
          <LienEspaceClient />
        </CarteHorsConnexion>
      </Page>
    );
  }

  return (
    <Page>
      <CarteHorsConnexion titre="Activez votre compte">
        {etat === ETATS.VERIFICATION && (
          <Loader text="Vérification du lien…" />
        )}

        {etat === ETATS.INDISPONIBLE && (
          <>
            <p className="carte-hors-connexion__alerte" role="alert">
              Nous n'arrivons pas à vérifier ce lien pour le moment. Réessayez
              dans quelques instants.
            </p>
            <button
              type="button"
              className="carte-hors-connexion__action"
              onClick={reessayer}
            >
              Réessayer
            </button>
          </>
        )}

        {(etat === ETATS.A_CONFIRMER || etat === ETATS.ACTIVATION) && (
          <>
            <p className="carte-hors-connexion__texte">
              Confirmez l'activation de votre compte pour accéder à votre espace
              client Perceval Assurance.
            </p>
            {echecActivation && (
              <p className="carte-hors-connexion__alerte" role="alert">
                L'activation n'a pas abouti. Vérifiez votre connexion internet
                puis réessayez.
              </p>
            )}
            <button
              type="button"
              className="carte-hors-connexion__action"
              onClick={activer}
              disabled={etat === ETATS.ACTIVATION}
            >
              {etat === ETATS.ACTIVATION
                ? "Activation en cours…"
                : "Activer mon compte"}
            </button>
          </>
        )}
      </CarteHorsConnexion>
    </Page>
  );
};

export default ActivateAccount;
